import enUI from '@linktivity/link-ui/lang/en';
import country from '@link/share/i18n/country/en';

import japanPrefectures from '@link/share/i18n/japanPrefectures/en';
import {
  NotificationType,
  PaymentType,
  PaymentPeriod,
  BookingType,
  IssuedStatus,
  CancelReason,
  ConfirmationType,
  DiscrepancyType,
  DiscrepancyReason,
  DiscrepancyStatus,
  DiscrepancyWaitingStatus,
  DiscrepancyInitiator,
  NotificationMethod,
  WalletOrderStatus,
  TransactionTypeMap
} from '@link/share/services/const';

export default {
  ...enUI,
  country,
  japanPrefectures,
  common: {
    account: 'Account',
    signOut: 'sign out',
    status: 'Status',
    action: 'Operation',
    parenthesis: '({{text}})',
    detail: 'Details',
    edit: 'Edit',
    add: 'Add',
    save: 'Save',
    or: 'or',
    delete: 'Delete',
    formTitle: '{{id}} ({{title}})',
    withSpace: '{{val1}} {{val2}}',
    withDashSeparated: '{{val1}} - {{val2}}',
    withSlashSeparated: '{{val1}} × {{val2}}',
    withCommaSeparated: '{{val1}} / {{val2}}',
    slash: '/',
    confirm: 'Confirm',
    editConfirm: 'Review Edit Details',
    ON: 'On',
    OFF: 'Off',
    cancel: 'Cancellation',
    confirmDelete: 'Are you sure you want to delete {{name}}?',
    yes: 'Yes',
    no: 'No',
    close: 'Close',
    has: 'Yes',
    hasNot: 'None',
    verify: 'Confirm',
    register: 'Register',
    continueEditing: 'Continue Editing',
    leaveCurrentPage: 'Leave this page',
    leaveCurrentPageConfirm: '{{name}} is still being edited',
    separator: ', ',
    pdf: 'PDF',
    mobile: 'Mobile',
    rangeSymbol: '~',
    pc: 'PC',
    grossPrice: 'Selling price',
    netPrice: 'Wholesale Price',
    sender: 'Sender',
    approver: 'Approver',
    discrepancy: 'Adjustment Details',
    adjustmentAmount: 'Adjustment Amount',
    commission: 'Commission',
    cancelFee: 'Cancellation Fee',
    refundAmount: 'Refund Amount',
    arrow: '→',
    colon: ':',
    empty: 'No Data',
    viewDetail: 'View Details',
    voucher: 'Voucher',
    printableVoucher: 'Printable',
    forDisplayVoucher: 'Display',
    supplier: 'Tour operator',
    agent: 'travel agency',
    complete: 'Completed',
    denied: 'Reject',
    downloadDetails: 'Download Statement',
    total: 'Search Results · {{total}}',
    infoSent: 'Information has been sent to {{target}}',
    currency: 'Currency',
    zip: 'ZIP',
    excel: 'CSV',
    download: 'Download',
    manual: 'Manual'
  },
  views: {
    contractsList: {
      title: 'Sales Permission Settings',
      supplier: 'Tour operator (ID)',
      agent: 'Travel agency (ID)',
      systemChargePercent: 'Current System Fee (%)',
      supplierCountry: 'Tour operator (Country/Region)',
      agentCountry: 'Travel agency (Country/Region)'
    },
    contractDetail: {
      addTitle: 'Add Contract',
      editTitle: 'Edit Contract',
      title: 'Contract Details',
      form: {
        supplier: 'Tour operator',
        agent: 'travel agency',
        status: 'Status',
        systemChargePercent: 'Current System Fee (%)'
      }
    },
    suppliersList: {
      supplierCustomId: 'Tour operator ID'
    },
    suppliersDetail: {
      title: 'Company Information',
      supplierCustomId: 'Tour operator ID',
      originalName: 'Tour operator name',
      englishName: 'Tour operator (EN)',
      status: 'Status',
      mainLanguage: 'Language Used',
      salesAccounts: 'Sales Representative',
      webUrl: 'Official site URL',
      countryCode: 'Country/Region',
      categories: 'Category',
      registrationCode: 'Qualified Invoice Issuer Registration Number',
      logoUrl: 'Logo',
      privacyPolicyType: 'Privacy Policy Processing',
      currency: 'Currency Used',
      transferFeePayer: 'Bank Transfer Fee Payment',
      billingMethod: 'Settlement Method',
      systemFeeRefundPolicyCustomer:
        'System Fee Refund (Customer Cancellation)',
      systemFeeRefundPolicySupplier:
        'System Fee Refund (Supplier Cancellation)',
      systemFeeRefundPolicyInvalid:
        'System Fee Refund (Invalidation Processing)'
    },
    suppliersAccount: {
      title: 'Account Management',
      role: 'Role',
      supplierCustomId: 'Tour operator',
      loginId: 'email address',
      username: 'Username',
      supportLanguages: 'Language Used'
    },
    suppliersAccountDetail: {
      addTitle: 'Add Account',
      editTitle: 'Edit Account',
      supplierId: 'Tour operator',
      loginId: 'Email address (login ID)',
      password: 'Password',
      supportLanguages: 'Languages Used',
      role: 'Role',
      notificationType: 'Notification Type',
      username: 'Username',
      phoneNumber: 'telephone number',
      personInCharge: 'Person in Charge',
      department: 'Department / Position',
      receiveNotifications: 'Receive Notification',
      notificationMethod: 'Notification Method',
      requireMfa: 'Two-Factor Authentication'
    },
    newAgent: {
      otaCustomId: 'Travel agency ID',
      title: 'Add travel agency',
      originalName: 'Travel agency name',
      englishName: 'Travel agency name (EN)',
      contractType: 'Signed Contract',
      mainLanguage: 'Primary Language',
      salesAccounts: 'Sales Representative',
      webUrl: 'Official site URL',
      country: 'Country/Region',
      currency: 'Currency Used',
      logoUrl: 'Logo',
      paymentType: 'Payment Method',
      paymentPeriod: 'Settlement Cycle'
    },
    agentAccountList: {
      role: 'Role',
      org: 'Group',
      loginId: 'User ID',
      username: 'Username',
      supportLanguages: 'Language Used'
    },
    newAgentAccount: {
      title: 'Add New Account',
      otaId: 'travel agency',
      otaOrgId: 'Group',
      loginId: 'Email address (login ID)',
      password: 'Password',
      role: 'Role',
      supportLanguages: 'Languages Used',
      notificationType: 'Notification Type',
      username: 'Username',
      phoneNumber: 'telephone number',
      personInCharge: 'Person in Charge',
      department: 'Department / Position',
      requireMfa: 'Two-Factor Authentication'
    },
    orgList: {
      country: 'Country/Region',
      parentOtaOrg: 'Parent Group',
      otaOrgName: 'Group Name'
    },
    newOrg: {
      title: 'Add Group',
      otaOrgCustomId: 'Group ID',
      otaOrgName: 'Group Name',
      otaId: 'travel agency',
      otaOrgId: 'Group ID',
      parentOtaOrgId: 'Parent Group',
      countryCode: 'Country/Region',
      logoUrl: 'Logo',
      activityIdWhitelist: 'Product Sales Settings'
    },
    login: {
      title: 'Welcome to GDS',
      email: 'email address',
      password: 'Password',
      button: 'Login',
      success: 'Logged in',
      link: 'Forgot Password? Click here',
      resettitle: 'Reset Password',
      reset: 'Send password reset email',
      send: 'Password reset URL has been sent to {{email}}. Please check your email and reset your password',
      resetError: 'Email sending failed. Please try again later.',
      googleLogin: 'Login with Google Account',
      register: 'New Registration / Inquiry Here',
      privacy: 'Privacy Policy',
      ipNotAllowed: 'A network error occurred. Please try again.'
    },
    enrollOTP: {
      title: 'Set Up Two-Factor Authentication',
      description:
        'To enhance your account security, scan the QR code with your authenticator app.',
      step1: '1. Install Google Authenticator on your smartphone',
      appStore: 'App Store (iOS)',
      googlePlay: 'Google Play (Android)',
      step2: '2. Scan the QR code',
      step3: "3. Enter the 6-digit code shown and you're done",
      qrLabel: 'QR Code',
      codeLabel: '6-digit code from authenticator app',
      submit: 'Verify & Enable',
      enrollError: 'Incorrect verification code. Please try again.'
    },
    verifyOTP: {
      title: 'Two-Factor Authentication',
      code: 'Verification Code',
      verify: 'Verify',
      verifyError: 'Incorrect verification code. Please try again.'
    },
    changePassword: {
      title: 'Change Password',
      oldPassword: 'Current【Password】',
      newPassword: 'New【Password】'
    },
    booking: {
      bookingCustomId: 'Booking Number',
      status: 'Status',
      purchasedDate: 'Application Date',
      participationDate: 'Participation Date',
      freeSale: 'Free sale',
      participationTime: 'Start Time',
      activityTitleSupplierLang: 'Product',
      planTitle: 'Plan',
      orderCount: 'Quantity',
      firstName: 'Participant Name',
      participantResidentRegion: 'Participant Country / Region of Residence',
      participantEmailAddress: 'Participant Email',
      destinationEmail: 'Contact Information',
      agentReservationNote: 'Agency Booking Number',
      agentBookingIdRemark: 'Travel Agency Booking Number (Remarks)',
      agentReservationSpecialNote: 'Travel Agency Booking Special Notes',
      supplierBookingId: 'Tour operator booking number',
      bookingDetail: 'Booking Details',
      bookingNumber: 'Booking Number',
      parentBookingNumber: 'Related Reservation Number',
      bookingType: 'Purchase Category',
      applicationDate: 'Application Date',
      bookingStatus: 'Booking Status',
      cancelledBySupplier: 'By supplier',
      issuedStatus: 'Usage Status',
      bookerName: 'Lead Booker Name',
      bookerEmail: 'Lead Booker Email',
      product: 'Product / Plan',
      productVoucherLang: 'Product / Plan (Booking Language)',
      voucherExpiration: 'Voucher Expiration Date',
      paymentInfo: 'Payment Information',
      salePrice: 'Selling price',
      commission: 'Commission',
      netPrice: 'Wholesale Price',
      free: 'Free sale',
      individual: 'Individual',
      download: 'Download',
      exchangeUrl: 'Exchange URL',
      openUrl: 'Open URL',
      discrepancies: 'Adjustment',
      cancelBooking: 'Cancel Booking',
      invalidBookingBtn: 'Invalidate Booking',
      invalidBooking: 'Do you want to invalidate this booking?',
      invalidBookingConfirmP1:
        'Do you want to invalidate the selected reservation?',
      invalidBookingConfirmP2:
        'This action cannot be undone. Please review before proceeding.',
      invalidBookingConfirmP3:
        'After invalidation, settlement reflection method can be selected in the next step',
      invalidBookingConfirmText: 'Invalidate',
      invalidBookingConfirmProcessing:
        'This booking is currently being processed. Do you still want to invalidate it?',
      invalidBookingSecondTitle:
        'Select Settlement Statement Reflection Method',
      invalidBookingOpt1Title:
        '1. Reflect in the Settlement Statement of the Month (or Week) of the Booking Confirmation Date',
      invalidBookingOpt1P1:
        'This booking will be reflected as a full refund in the settlement statement of the month (or week) to which the booking confirmation date belongs.',
      invalidBookingOpt1P2:
        'If the invalidation date/time has passed the settlement deadline of the month (or week) to which the booking confirmation date belongs, and the settlement statement has already been issued, the settlement statement for that month (or week) will be reissued.',
      invalidBookingOpt1P3:
        'After the invalidation process is complete, please be sure to re-download and verify the latest version of the settlement statement.',
      invalidBookingOpt1P4: 'In addition, this booking',
      invalidBookingOpt1P5:
        'will not appear in the settlement statement of the month (or week) to which the invalidation date/time belongs.',
      invalidBookingOpt2Title:
        '2. Reflect in the Settlement Statement of the Month (or Week) of the Invalidation Date/Time',
      invalidBookingOpt2P1:
        'This booking will be reflected as a full refund in the settlement statement of the month (or week) to which the invalidation date/time belongs.',
      invalidBookingOpt2P2:
        'Even if the invalidation date/time has passed the settlement deadline of the month (or week) to which the booking confirmation date belongs and the settlement statement has already been issued, the settlement statement will not be reissued.',
      cancelFeeAndRefundAmount: 'Cancellation Fee and Refund Amount',
      currentDateTime: 'Current Date & Time',
      amount: 'Amount',
      paidAmount: 'Payment Amount',
      cancelFee: 'Cancellation Fee',
      refundAmount: 'Refund Amount',
      confirmedBy: 'Verifier Name',
      performCancel: 'Execute Cancellation',
      cancelResult: 'Cancellation completed.',
      cancelSucceed: 'Cancellation completed',
      cancelPending:
        'Cancellation is being processed. Awaiting supplier response.',
      unitAdditionalLabel: '{{unitTitle}}{{unitIndex}} additional booking info',
      cancelReason: 'Cancellation Reason',
      cancelComment: 'Cancellation Comment',
      denyReason: 'Rejection Reason',
      name: '{{firstName}} {{lastName}}',
      otaName: 'Seller name',
      endUserRefundAmount: 'End User Refund Amount',
      paymentRefundAmount: 'Payment Refund Amount',
      cancelFeeFromTravelerToAgent: 'Cancellation Fee (Traveler to Agent)',
      cancelFeeFromAgentToLink: 'Cancellation Fee (Agent to LINKTIVITY)',
      finalSettlementToLink: 'Final Settlement Amount (to LINKTIVITY)',
      paymentRefundAmountOta: 'Payment Refund Amount (OTA)',
      cancelFeeFromLinkToSupplier: 'Cancellation Fee (LINKTIVITY to Supplier)',
      systemCharge: 'System Charge',
      finalSettlementFromLink: 'Final Settlement Amount (from LINKTIVITY)',
      linkCancelFee: 'Cancellation Fee (LINKTIVITY Portion)',
      linkRevenue: 'LINKTIVITY Revenue'
    },
    discrepancies: {
      title: 'Adjustment Request {{type}}',
      finished: 'Sent',
      return: 'Back to Booking Details',
      send: 'Send',
      receive: 'Receive',
      discrepancy: 'Adjustment',
      discrepancyType: 'Adjustment Details',
      reasonDescription: 'Details',
      reason: 'Reason',
      priceAdjust: 'Adjustment Amount (Difference)',
      grossAdjustmentAmount: 'Selling price',
      netAdjustmentAmount: 'Wholesale Price',
      addItem: 'Add an item',
      bookingInfo: 'Booking Information',
      adjustmentItem: 'Adjustment Item',
      verifier: 'Verifier Name',
      applicant: 'Applicant',
      enterName: 'Please enter your name',
      apply: 'Apply',
      adjustmentAmount: 'Adjustment Amount',
      originalGrossAmount: 'Original Sales Price',
      originalNetAmount: 'Original Wholesale Price',
      adjustedGrossAmount: 'Adjusted Selling Price',
      adjustedNetAmount: 'Adjusted Wholesale Price',
      requiredAmount: 'Please enter amount',
      applySuccessTitle: 'Adjustment request has been sent',
      approveSuccessTitle: 'Adjustment request was approved',
      denySuccessTitle: 'Adjustment request was rejected',
      successMsg:
        'The approved adjustment amount will be reflected in the most recent payment month',
      alert:
        'Once confirmed, the entered adjustment items will be sent to {{target}} for approval',
      waitingTip:
        'The following adjustment items have been sent to {{target}}. Currently awaiting {{target}} approval',
      reviewTip: 'Do you approve this adjustment item?',
      approve: 'Approve',
      deny: 'Reject'
    },
    bookingList: {
      title: 'Booking Management',
      filter: {
        bookingCustomId: 'Booking Number',
        activityTitle: 'Product Name',
        planTitle: 'Plan Name',
        status: 'Status',
        participantName: 'Lead Booker Name',
        participantEmail: 'Lead Booker Email',
        purchasedAtStart: 'Application Date',
        participateDateStart: 'Participation Date (Local Product)',
        agentReservationNo: 'Travel agency reservation number',
        supplierBookingId: 'Tour operator booking number'
      },
      participantResidentRegion: 'Country/Region',
      refreshIssuedStatus: 'Refresh usage status',
      refreshIssuedStatusSuccess:
        'Usage status refreshed (Matched: {{matched}}, Refreshed: {{refreshed}}, Skipped: {{skipped}}, Failed: {{failed}})'
    },
    bulkBookingList: {
      title: 'Booking Management',
      reservationNumber: 'Booking Number',
      status: 'Status',
      submitDate: 'Submission Date',
      product: 'Product',
      plan: 'Plan',
      agent: 'travel agency'
    },
    discrepancyList: {
      title: 'Adjustment',
      purchaseDate: 'Date of purchase',
      participationDate: 'Participation Date',
      keyword: 'Keyword',
      activity: 'Product',
      plan: 'Plan',
      reservationNumber: 'Booking Number',
      transactionType: 'Transaction Type',
      adjustmentStatus: 'Adjustment Status',
      salesPrice: 'Selling price',
      wholesalePrice: 'Wholesale Price',
      sender: 'Sender',
      senderFormat: '{{senderName}} ({{initiator}})'
    },
    notificationInbox: {
      title: 'Notifications',
      all: 'All ({{count}})',
      summary: '{{total}} total / {{unread}} unread',
      empty: 'No notifications',
      detailPlaceholder: 'Select a notification on the left to view details.',
      detailLoadError: 'Failed to load the notification details'
    },
    invoiceChange: {
      title: 'Amount Adjustment',
      adjustmentDate: 'Adjustment Date',
      adjustedBy: 'Adjusted By',
      invoiceAmount: 'Billing Amount',
      adjustmentAmount: 'Adjustment Amount',
      paymentAmount: 'Payment Amount',
      adjustmentReason: 'Adjustment Reason',
      submit: 'Confirm',
      addFile: 'Attach File',
      historyTitle: 'Amount Adjustment History',
      finalAmount: 'Adjusted Payment Amount'
    }
  },
  const: {
    cancelErrorCode: {
      BOOKING_NOT_FOUND: 'Booking not found',
      BOOKING_ALREADY_CANCELLED: 'Already Cancelled',
      CANCEL_DEADLINE_PASSED: 'Cancellation period has expired',
      BOOKING_ALREADY_ISSUED:
        'This booking has already been issued and cannot be cancelled',
      BOOKING_STATUS_NOT_CANCELLABLE:
        'This booking cannot be cancelled in its current status',
      BOOKING_INVALIDATION_IN_PROGRESS:
        'This booking is being invalidated and cannot be cancelled',
      BOOKING_DECLINE_INSTEAD_OF_CANCEL:
        'This booking needs to be declined instead of cancelled',
      BOOKING_NOT_CANCELLABLE: 'This booking cannot be cancelled',
      CANCEL_NOT_STARTED: 'The cancellation process has not been started',
      CANCEL_REFUND_CHANGED:
        'The cancellation fee or refund amount has changed',
      BOOKING_ADAPTER_BOOKING_NOT_CANCELLABLE:
        'The cancellation was rejected by the supplier',
      BOOKING_ADAPTER_EXTERNAL_FAILED:
        'The cancellation was rejected by the supplier',
      BOOKING_ADAPTER_EXTERNAL_PENDING:
        'Waiting for confirmation from the supplier. Please try again later',
      RETRYABLE: 'Please try again later',
      UNKNOWN: 'This booking cannot be cancelled'
    },
    cancelDeadline: 'Cancellation deadline: {{deadline}}',
    language: {
      JAPANESE: 'Japanese',
      ENGLISH: 'English',
      CHINESE: 'Chinese (Simplified)',
      CHINESE_T: 'Chinese (Traditional)',
      KOREAN: 'Korean'
    },
    partnerCategory: {
      RAILWAY: 'Railway',
      BUS: 'Bus',
      FERRIES: 'Ferry',
      RENTAL_CAR: 'Rental Car',
      SIGHTSEEING_SPOT: 'Tourist Spot',
      FOOD: 'restaurant',
      EXPERIENCE: 'Experience',
      ACCOMMODATION: 'Hotel',
      TOUR: 'Tour',
      ACTIVITY: 'Activity',
      CHARTER: 'Charter',
      LINKTIVITY: 'LINKTIVITY',
      OTHERS: 'Other'
    },
    privacyPolicyType: {
      EMAIL_NOT_SHOW: 'Hide Customer Email',
      NAME_NOT_SHOW: 'Hide Customer Name',
      REGISTERED_CODE_NOT_SHOW: 'Hide Booking Number',
      OTA_BOOKING_ID_NOT_SHOW: 'Hide Travel Agency Booking Number',
      SUPPLIER_BOOKING_ID_NOT_SHOW: 'Hide Tour Operator Booking Number'
    },
    transferFeePayer: {
      LINK: 'LINKTIVITY',
      SUPPLIER: 'Tour operator'
    },
    billingMethod: {
      PURCHASE_DATE: 'Date of purchase',
      USAGE_DATE: 'Usage Date'
    },
    systemFeeRefundPolicy: {
      NO_REFUND: 'No Refund',
      ALL_REFUND: 'Full Refund'
    },
    role: {
      ADMIN: 'Administrator',
      VIEWER: 'Viewer',
      EDITOR: 'Editor',
      OPERATOR: 'Operator'
    },
    contractType: {
      equivalent: 'TERMS_OF_SERVICE_V20181101 Equivalent',
      nonEquivalent: 'TERMS_OF_SERVICE_V20181101 Not Equivalent'
    },
    checklistType: {
      RESTRICTION: 'Participation Restrictions',
      REQUIRED_ITEM_TO_BRING_AND_ATTIRE:
        'Required Clothing / Items for Participation',
      REQUIRED_OTHER: 'Other Required Items at Participation',
      REQUIRED_ADDITIONAL_NOTE: 'Remarks/Other',
      NICE_TO_HAVE_ITEM_TO_BRING_AND_ATTIRE: 'Recommended Clothing & Items',
      NICE_TO_HAVE_OTHER: 'Other Recommendations',
      INCLUDED: 'Included Items'
    },
    notificationType: {
      [NotificationType.NoNotification]: 'No Notification',
      [NotificationType.ActivityOperation]: 'Product-related',
      [NotificationType.BookOperation]: 'Booking-related',
      [NotificationType.FinanceOperation]: 'Settlement & Finance',
      [NotificationType.SystemOperation]: 'Notices from LINK'
    },
    inboxCategory: {
      [NotificationType.ActivityOperation]: 'Product-related',
      [NotificationType.BookOperation]: 'Booking-related',
      [NotificationType.FinanceOperation]: 'Settlement & Finance',
      [NotificationType.SystemOperation]: 'Notices from LINK',
      [NotificationType.UndefinedNotification]: 'Other',
      [NotificationType.NoNotification]: 'None'
    },
    notificationMethod: {
      [NotificationMethod.UndefinedMethod]: 'Undefined',
      [NotificationMethod.Email]: 'Email',
      [NotificationMethod.InternalMessage]: 'Inbox Message'
    },
    paymentType: {
      [PaymentType.PostBankTransfer]: 'Postpaid (Bank Transfer)',
      [PaymentType.PreLinkpay]: 'Online Payment (Prepaid)',
      [PaymentType.PostLinkpay]: 'Postpaid (LinkPay)',
      [PaymentType.PreCharge]: 'Bank Transfer (Prepaid)'
    },
    paymentPeriod: {
      [PaymentPeriod.Weekly]: 'Weekly',
      [PaymentPeriod.Monthly]: 'Monthly',
      [PaymentPeriod.HalfMonthly]: 'Biweekly'
    },
    attachmentType: {
      PDF: 'PDF',
      IMAGE: 'Image'
    },
    bookingField: {
      PARTICIPANT_EMAIL_ADDRESS: 'Participant Email',
      HOTEL_NAME: 'Accommodation Name',
      HOTEL_ADDRESS: 'Accommodation Address',
      HOTEL_RESERVATION_LAST_NAME: 'Hotel Representative Last Name',
      HOTEL_RESERVATION_FIRST_NAME: 'Hotel Representative First Name',
      HOTEL_TEL: 'Accommodation Phone Number',
      ARRIVAL_DATE: 'Local Arrival Date',
      ARRIVAL_TIME: 'Arrival Time',
      ARRIVAL_FLIGHT_NUMBER: 'Flight Arrival Number',
      DEPARTURE_DATE: 'Departure Date',
      DEPARTURE_TIME: 'Departure Time',
      DEPARTURE_FLIGHT_NUMBER: 'Flight Departure Number',
      DESTINATION_EMAIL: 'Local Contact (Email Address)',
      DESTINATION_TEL: 'Local Contact (Phone Number)',
      PARTICIPANT_RESIDENT_REGION: 'Participant Country / Region of Residence',
      PARTICIPANT_LANGUAGE: 'Participant Language'
    },
    extendedBookingField: {
      PASSENGERS_QUANTITY: 'Number of Passengers',
      PREFERRED_START_TIME: 'Preferred Start Time',
      PREFERRED_PICK_UP_LOCATION: 'Pickup / Boarding Location',
      PREFERRED_DROP_OFF_LOCATION: 'Drop-off / Drop Location',
      PARTICIPANTS_QUANTITY: 'Number of Participants',
      LUGGAGE_QUANTITY: 'Total Suitcase Count',
      CHILDREN_WITHOUT_SEAT_QUANTITY: 'Infant (No Seat Required)',
      CHILD_SEAT_QUANTITY_PAID: 'Child Seat (Paid on-site)',
      CHILD_SEAT_QUANTITY_FREE: 'Child Seat (Free)',
      PREFERRED_GUIDE_LANGUAGE_CODE: 'Preferred Guide Language',
      PREFERRED_DRIVER_LANGUAGE_CODE: 'Driver Language Preference'
    },
    extendedParticipantField: {
      PASSPORT_FIRST_NAME: 'Participant Given Name (Passport Romanization)',
      PASSPORT_LAST_NAME: 'Participant Surname (Passport Romanization)',
      PASSPORT_NATIONALITY: 'nationality',
      PASSPORT_NUMBER: 'Passport Number',
      DATE_OF_BIRTH: 'Date of Birth',
      AGE: 'age',
      GENDER: 'Gender',
      EYESIGHT: 'Vision',
      WEIGHT_KG: 'Weight (kg)',
      HEIGHT_CM: 'Height (cm)',
      SHOE_SIZE_CM: 'Shoe size (cm)',
      CLOTHES_SIZE: 'Clothing Size',
      VEGETARIAN_MEALS: 'Vegetarian food preferred',
      DIVING_EXPERIENCE_TIMES: 'Number of Diving Experiences',
      RENTAL_EQUIPMENTS_FREE: 'Equipment rental requested (free of charge)',
      RENTAL_EQUIPMENTS_PAY_LOCALLY:
        'Equipment rental requested (payment at location)'
    },
    bookingStatus: {
      REQUEST_PENDING: 'request',
      REQUEST_REJECTED: 'Rejected',
      CONFIRMED: 'Confirmed',
      CANCELLED_BY_TRAVELER: 'Cancellation (Customer)',
      CANCELLED_BY_SUPPLIER: 'Cancellation (Supplier)',
      INVALID: 'Invalidate',
      CANCEL_FAILED: 'Cancellation Failed',
      CANCEL_PENDING: 'Cancellation Pending'
    },
    bulkBookingStatus: {
      SUBMITTED: 'Submitted',
      PAID: 'Remitted',
      ACCEPTED: 'Approval Completed',
      QUEUED: 'Pending Issuance',
      ISSUED: 'Issued',
      PENDING: 'Pending'
    },
    bulkBookingAction: {
      SUBMIT: 'Submit',
      PAY: 'Remittance',
      ACCEPT: 'Approve',
      PEND: 'On Hold',
      ISSUE: 'Ticket Issuance',
      FINISH: 'Completed'
    },
    confirmationType: {
      [ConfirmationType.FreeSale]: 'Participation Date Specified (Free Sale)',
      [ConfirmationType.FreeSaleOpenDate]:
        'No need to specify participation date (free cell)',
      [ConfirmationType.Inventory]: 'Participation Date Specified (Real-time)',
      [ConfirmationType.Request]: 'Participation Date Required (Request)'
    },
    // use for bookingDetail page
    bookingConfirmationType: {
      [ConfirmationType.FreeSale]: 'Free sale',
      [ConfirmationType.FreeSaleOpenDate]: 'Free sale',
      [ConfirmationType.Inventory]: 'Instant Booking',
      [ConfirmationType.Request]: 'Request Booking'
    },
    walletOrderStatus: {
      [WalletOrderStatus.StatusPending]: 'Unpaid',
      [WalletOrderStatus.StatusPaying]: 'Charge Incomplete',
      [WalletOrderStatus.StatusPaid]: 'Remittance Completed',
      [WalletOrderStatus.StatusRejected]: 'Rejected',
      [WalletOrderStatus.StatusCancelled]: 'Cancelled',
      [WalletOrderStatus.StatusConfirmed]: 'Top-up Completed',
      [WalletOrderStatus.StatusRefunded]: 'Refunded'
    },
    transactionTypeMap: {
      [TransactionTypeMap.TransactionTypeCancelRefund]: 'Cancelled',
      [TransactionTypeMap.TransactionTypePurchase]: 'Confirmed',
      [TransactionTypeMap.TransactionTypeDiscrepancy]: 'Adjustment Completed',
      [TransactionTypeMap.TransactionTypeInvalid]: 'Invalidated'
    },
    discrepancyStatus: {
      [DiscrepancyStatus.Waiting]: 'Awaiting approval',
      [DiscrepancyStatus.Approved]: 'Adjustment complete',
      [DiscrepancyStatus.Rejected]: 'Rejected'
    },
    discrepancyWaitingStatus: {
      [DiscrepancyWaitingStatus.Deliver]: 'Awaiting approval',
      [DiscrepancyWaitingStatus.Receive]: 'Awaiting approval response'
    },
    discrepancyInitiator: {
      [DiscrepancyInitiator.Ota]: 'Travel Agency',
      [DiscrepancyInitiator.Supplier]: 'Tour operator'
    },
    discrepancyType: {
      [DiscrepancyType.Refund]: 'Refund',
      [DiscrepancyType.AdditionalCharge]: 'Additional Charge'
    },
    discrepancyReason: {
      [DiscrepancyReason.AdditionalServices]: 'Product Additional Fee',
      [DiscrepancyReason.MissedServices]: 'Refund due to non-provision',
      [DiscrepancyReason.CustomerComplaint]: 'Customer Complaint Refund',
      [DiscrepancyReason.DoubleCharge]: 'Double Billing',
      [DiscrepancyReason.FeeForBookingChange]: 'Change Fee',
      [DiscrepancyReason.PartialCancel]: 'Partial Cancellation',
      [DiscrepancyReason.SelfAdjustment]: 'Individual Adjustment',
      [DiscrepancyReason.Other]: 'Other'
    },
    bookingType: {
      [BookingType.Bulk]: 'Bulk Processing',
      [BookingType.Single]: 'Individual Processing'
    },
    issuedStatus: {
      [IssuedStatus.Issued]: 'Used',
      [IssuedStatus.NotIssued]: 'Unused',
      [IssuedStatus.Partial]: 'Partial Use',
      [IssuedStatus.Disable]: 'Invalid'
    },
    cancelReason: {
      [CancelReason.BadWeather]: 'Bad Weather',
      [CancelReason.BookedByMistake]: 'Booked by mistake',
      [CancelReason.DoubleBooking]: 'Duplicate Reservation',
      [CancelReason.FlightIssues]:
        'Due to flight cancellation, delay, or change',
      [CancelReason.FoundCheaperRate]: 'I found an even cheaper price.',
      [CancelReason.Other]: 'Other',
      [CancelReason.ParticipantMinimumNotMet]: 'Minimum Participants Not Met',
      [CancelReason.ParticipantOrDateChange]:
        'Change Booking Date or Number of People',
      [CancelReason.PrivateBuyout]: 'Group booking - fully booked',
      [CancelReason.SameSupplierActivityChange]:
        'Change to another product under the same operator',
      [CancelReason.SeparateSupplierActivityChange]:
        'Change to a product from a different tour operator.',
      [CancelReason.Sickness]: 'Poor Physical Condition',
      [CancelReason.OtaCancelWithoutReason]: 'OTA Unknown Reason Cancellation',
      [CancelReason.TechnicalDifficulties]:
        'Equipment Failure or Unexpected Issue'
    },
    category: {
      RAILWAY_TICKET: 'Train Ticket',
      AIRPORT_TRANSPORTATION: 'Airport Access',
      SHINKANSEN: 'Shinkansen',
      EXPRESS_BUS: 'Highway bus',
      BUS_TOUR: 'Bus Tour',
      CRUISES: 'Ferry / Cruise',
      RENTAL_CAR: 'Rental Car',
      CHARTER: 'Charter',
      ATTRACTION: 'Facility (Admission Ticket)',
      THEME_PARK: 'Theme Park',
      MUSEUM_GALLERY: 'Museum / Art Gallery',
      AQUARIUM_ZOO: 'Aquarium / Zoo',
      TEMPLES_SHINES: 'Temples / Shrines',
      TOWER_BUILDING: 'Observatory / Tower',
      JAPANESE_RESTAURANT: 'Japanese Restaurant',
      WESTERN_RESTAURANT: 'Western Restaurant',
      CHINESE_RESTAURANT: 'Chinese Restaurant',
      OTHER_RESTAURANT: 'Restaurants (Other)',
      DESSERT_BEVERAGE: 'Dessert / Drinks',
      SIGHTSEEING_TOUR: 'Sightseeing Tour',
      MARINE_SPORTS: 'Marine sports',
      OUTDOOR_ACTIVITIES: 'Outdoor Activity',
      ONSEN: 'Hot Spring',
      SPA_MASSAGE: 'Spa / Massage',
      JAPANESE_CULTURAL_EXPERIENCE: 'Japanese Cultural Experience',
      JAPANESE_CRAFT_EXPERIENCE: 'Japanese Craft Experience',
      JAPANESE_COOKING_EXPERIENCE: 'Japanese Cooking Experience',
      OTHER_EXPERIENCE: 'Other Experiences',
      HOTEL: 'Hotel',
      RYOKAN: 'Ryokan',
      VACATION_RENTAL: 'Vacation Rental',
      BUNDLE: 'Set',
      PASS: 'Pass',
      OTHERS: 'Other'
    },
    possibleIntervalShow: {
      DAY: 'Within {{amount}} days',
      MONTH: 'Within {{amount}} months'
    },
    voucherExpirationFromPurchase: {
      DAY: '{{time}} days from the date of purchase',
      MONTH: '{{time}} months from the date of purchase',
      SAME_DAY: 'On the date of purchase'
    },
    voucherExpirationFromActivity: {
      DAY: '{{time}} days from participation date',
      MONTH: '{{time}} months from participation date',
      SAME_DAY: 'On the participation date'
    }
  },
  week: {
    SUNDAY: 'Sunday',
    MONDAY: 'Monday',
    TUESDAY: 'Tuesday',
    WEDNESDAY: 'Wednesday',
    THURSDAY: 'Thursday',
    FRIDAY: 'Friday',
    SATURDAY: 'Saturday'
  },
  bankInfo: {
    swiftCode: 'SWIFT Code',
    bankName: 'Bank Name',
    bankCode: 'Bank Code',
    bankBranchCode: 'Branch Code',
    bankBranchName: 'Branch Name',
    bankAddress: 'Bank Address',
    bankAccountNumber: 'Account Number',
    accountHolderName: 'Account Holder Name'
  },
  validation: {
    required: '{{name}} is required',
    invalid: 'Please enter a valid {{name}}',
    password: 'Please use 8+ characters with letters, numbers, and symbols',
    imageType: 'Please select an image',
    fileSize: 'Please select a file under {{size}}MB',
    range: '{{name}} must be between {{min}} and {{max}}',
    greaterThan: '{{name}} must be greater than {{min}}',
    notEqual: '{{name}} cannot accept {{value}}',
    integer: '{{name}} must be a whole number',
    requiredSelect: 'Please select',
    alphabet:
      'Please enter uppercase letters (spaces allowed, numbers not allowed)',
    otaCustomIdFormat:
      'Use 1-16 characters (uppercase letters, numbers, underscores), starting with a letter or number',
    maxLength: '{{name}} must be {{max}} characters or fewer',
    personName:
      "{{name}} cannot contain numbers or symbols (' - . are allowed)",
    telFormat:
      'Please use only digits, "+" and "-", with 8 to 20 characters total',
    flightNumber:
      'Please enter 3-8 alphanumeric characters including both letters and numbers',
    dateNotBefore: '{{name}} must be on or after {{min}}',
    dateNotAfter: '{{name}} must be on or before {{max}}',
    passportName:
      "Please enter the name as printed in the passport (letters, spaces and ' - . only)",
    passportNumber: 'Please enter 6-12 alphanumeric characters',
    ageMismatch:
      'Does not match the age calculated from the date of birth ({{age}})'
  },
  messages: {
    newSuccess: 'Added',
    updateSuccess: 'Updated',
    deleteSuccess: 'Deleted',
    copySuccess: 'Copy',
    updateFailed: 'Could not update',
    dateMax3Months: 'Please specify a date range within 3 months',
    downloadSuccess: 'Download completed'
  },
  confirmDelete: {
    title: 'Please check',
    prompt: 'Are you sure you want to delete?'
  },
  autoLogout: {
    title: 'You will be logged out soon',
    description1:
      'For security, you will be automatically logged out after 9 hours of inactivity.',
    description2: 'Click "Continue" to stay logged in.',
    logout: 'Logout now',
    continue: 'Continue'
  },
  firebase: {
    'auth/invalid-credential': 'Incorrect login email or password',
    'auth/email-already-in-use': 'This email address is already registered.',
    'auth/too-many-requests':
      'Login attempts exceeded. Please try again later or reset your password'
  },
  wallet: {
    feeRate: 'Fee Rate',
    fee: 'Fee',
    deductAmount: 'Total Amount',
    proceedToPayment: 'Agree and Proceed to Payment',
    invalidAmount: 'Please enter a valid amount'
  },
  transaction: {
    csvApplyDateTimezoneNote:
      '*Note: The application date in the settlement statement CSV is based on the product time zone set by the operating company, not the travel agency’s local (browser) time.'
  },
  activityDetail: {
    title: 'Product Details',
    planTitle: 'Plan Details',
    faq: 'FAQ',
    location: '{{country}}',
    city: '・{{city}}',
    activity: {
      content: 'Product Content',
      api: 'API Code',
      cancelPolicy: 'Cancellation Policy',
      productId: 'Product ID',
      operator: 'Tour operator',
      timezone: 'Time Zone',
      currency: 'Currency',
      language: 'Display Language',
      category: 'Category',
      departure: 'Departure Location',
      destination: 'Destination',
      activityId: 'Activity ID',
      activityName: 'Activity Name',
      planId: 'Plan ID',
      planName: 'Plan Name',
      planStartTimeId: 'Plan Start Time ID',
      planStartTimeName: 'Plan Start Time Name',
      startTime: 'Start Time',
      planUnitItemsId: 'Plan Unit Items ID',
      planUnitName: 'Plan Unit Name'
    },
    plans: {
      description: 'Booking Information',
      notes: 'Notes',
      schedule: 'Schedule',
      locations: 'Location',
      additionalBookingInfo: 'Additional Booking Info',
      startTime: 'Start Time',
      noTimeLimit: 'Unlimited',
      availableCount: 'Bookable Quantity',
      availableCountShow: '{{min}} ~ {{max}}',
      availablePeriod: 'Publication Period',
      availablePeriodShow:
        '{{startY}}-{{startM}}-{{startD}} ~ {{endY}}-{{endM}}-{{endD}}',
      possibleInterval: 'Booking Available Period',
      reservationDeadline: 'Booking Deadline',
      reservationDeadlineShow:
        'Please book by {{time}} {{day}} days before participation date',
      reservationDeadlineShowToday: 'Please book by {{time}} on the day',
      voucherExpiration: 'Voucher Expiration Date',
      voucherExpirationAnnualCutOff:
        'Annual Increment Reference Date: Purchases before {{annualFixedDate}} expire by the relative fixed date {{annualCutOffDate}} of the same year, and purchases on/after {{annualFixedDate}} expire by the relative fixed date {{annualCutOffDate}} of the following year',
      optionalBookingFields: 'Representative Information (Optional)',
      optionalExtendedBookingFields: 'Other Information (Optional)',
      optionalParticipantFields: 'User Info *Per Participant (Optional)',
      requiredBookingFields: 'Representative Information (Required)',
      requiredExtendedBookingFields: 'Other Information (Required)',
      requiredParticipantFields: 'User Info *Per Participant (Required)',
      customFields: 'Custom booking information',
      customFieldsShow: '{{title}} : {{des}}',
      meetingPlace: 'Meeting point',
      dismissalPlace: 'Drop-off Location',
      pickupPlace: 'Pickup Location',
      dropOffPlace: 'Drop-off Location'
    }
  }
};
